const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: 8,
    boxShadow: "none!important",
    alignItems: "center"
  }),
  tableheader: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "11pt",
    textAlign: "center"
  },
  tableheaderlast: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "11pt",
    textAlign: "center"
  },
  tablecontent: {
    color: "black",
    fontSize: "12pt",
    textAlign: "center"
  },
  tablecontent_first: {
    width: "320px",
    color: "black",
    fontSize: "12pt",
    textAlign: "left"
  },
  tablecontentlast: {
    //fontWeight: "bold",
    color: "black",
    fontSize: "12pt"
  },
  failState: {
    color: theme.palette.fail
  },
  passState: {
    color: theme.palette.success
  },
  div_table1: {
    paddingTop: 30
  },
  div_image: {
    paddingTop: 50
  },
  div_table2: {
    height: 300,
    overflow: "auto"
  },
  defaultText: {
    fontSize: "14px"
  },
  tableheader_first: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "11pt",
    textAlign: "left",
    width: "320px"
  },
  passedText: {
    color: "#4CAF50",
    fontSize: "14px"
  },
  failedText: {
    color: "#FF5252",
    fontSize: "14px"
  },
  totalGrid: {
    borderRight: "0.5px solid #D3D3D3",
    textAlign: "center"
  },
  totalGridLast: {
    textAlign: "center",
    flexBasis: "15%"
  },
  infoHead: {
    display: "flex",
    margin: "0 Auto",
    width: "80px"
  },
  pass: {
    margin: theme.spacing.unit,
    textAlign: "center"
  },
  table2: {
    overflow: "auto",
    height: 380
  },
  logo: {
    width: "600px",
    height: "400px",
    maxHeight: "400px",
    display: "inline-block",
    maxWidth: "600px",
    objectFit: "cover",
    transform: "translate(100px, -30px)"
  },
  polarity: {
    fontSize: "14px",
    paddingTop: "35px",
    fontWeight: "bold"
  },
  infoText: {
    paddingTop: "2px",
    paddingLeft: "3px",
    whiteSpace: "pre"
  },
  speedIndicator: {
    width: "400px",
    height: "120px",
    maxHeight: "120px",
    display: "inline-block",
    maxWidth: "400px",
    objectFit: "cover",
    transform: "translate(150px, 50px)"
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/common/results/views/qualification/styles.js